import { Box, Grid, makeStyles, Theme, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import { Button, Paper, PaperBorderType } from "@roc/ui";
import { useDocumentStore } from "@roc/feature-documents";
import { PayoffCard } from "./cardComponents/payoffCard";
import { GetApp } from "@material-ui/icons";

const useStyles = makeStyles((theme: Theme) => ({

}));

export const PayoffServicerFeesCard = observer(({ }) => {
  const classes = useStyles();
  const {
    documentStore: {
      documentFormStore: { payoffCalculatorStore },
    },
  } = useDocumentStore();

  return (
    <Paper titleComponent={
      <Box display="flex" p={2}>
        <Grid container justifyContent="space-between">
          <Grid item>
            <Typography variant="h5">
              Servicer Fees
            </Typography>
          </Grid>
          <Grid item>
            <Grid container justifyContent="flex-end" spacing={1}>
              <Grid item>
                <Button
                  testId="downloadServicerFeesExcel"
                  variant="outlined"
                  size="small"
                  color="primary"
                  onClick={() => payoffCalculatorStore.downloadPayoffExcel('fees')}
                  startIcon={<GetApp />}
                >
                  Download Excel
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    } borderType={PaperBorderType.SOLID_BORDER}>
      <PayoffCard
        columns={[
          {
            label: 'Name',
            value: 'name',
            width: '50%'
          },
          {
            label: 'Amount',
            value: 'amount',
            type: 'currency',
            width: '50%'
          }
        ]}
        rows={payoffCalculatorStore?.servicerFees}
        total={payoffCalculatorStore?.aggregatedServicerFees}
        compactView={true}
      />
    </Paper>
  );
});